import { APP_CONFIG } from "config/appConfig";

/**
 * On-prem deployments expose Network and Auxiliary Hub abstractions; cloud
 * deployments do not. These labels switch the UI text accordingly so the
 * conditional doesn't have to be duplicated at every column header.
 */
export const GATEWAY_LABEL = APP_CONFIG.APP_IS_ONPREM
    ? "Gateway/Network"
    : "Gateway";

export const LDSU_UUID_LABEL = APP_CONFIG.APP_IS_ONPREM
    ? "LDSU/Auxiliary Hub UUID"
    : "LDSU UUID";
